// @flow
import React from 'react';
import injectSheet from 'react-jss';
import {
  FONT_FAMILY_ROBOTO
} from 'shared/constants';

type Props = {
  classes: Object,
  colorTheme: string,
  value: string,
  placeholder: string,
  disabled: Boolean,
  error: string,
  onChange: Function,
  onBlur: Function
};

function InputField({ classes: c, value, onChange, onBlur, placeholder,
  disabled, error }: Props) {
  return (
    <div>
      <input
        className={c.inputField}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
      />
      { error &&
        <span className={c.errorMsg}>
          <i className="material-icons">error</i>
          {error}
        </span>
      }
    </div>
  );
}

const styles = {
  inputField: {
    border: 'none',
    borderBottom: '1px solid hsl(0, 0%, 40%)',
    backgroundColor: 'transparent',
    padding: '14px 0px',
    borderRadius: '0',
    fontFamily: FONT_FAMILY_ROBOTO,
    fontSize: '16px',
    color: (props) => {
      if (props.colorTheme === 'DARK') {
        return 'white';
      }
      return 'black';
    },
    fontWeight: '300',
    width: '100%',
    outline: 'none',
    transition: 'all .2s ease-in-out',
    '&:disabled': {
      cursor: 'not-allowed'
    },
    '&::placeholder': {
      color: (props) => {
        if (props.colorTheme === 'DARK') {
          return '#FFFFFF';
        }
        return 'black';
      }
    },
    '&:focus': {
      borderBottom: '1px solid hsl(0, 0%, 80%)'
    }
  },
  errorMsg: {
    color: 'hsl(360, 100%, 40%)',
    fontSize: '16px',
    display: 'flex',
    alignItems: 'center',
    marginTop: '5px',
    '&> .material-icons': {
      fontSize: '18px',
      marginRight: '5px'
    }
  }
};

export default injectSheet(styles)(InputField);
